"use client"

import { Navbar, Footer } from "@/components/index"

export function BlogDetailSkeleton() {
  return (
    <div className="min-h-screen bg-bg">
      <Navbar />

      {/* Hero Section Skeleton */}
      <section className="pt-24 md:pt-32 pb-8 md:pb-12 bg-gradient-to-b from-bg to-bg-alt">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
          {/* Back Link */}
          <div className="h-4 w-24 bg-border/50 rounded animate-pulse mb-6 sm:mb-8" />

          {/* Title */}
          <div className="space-y-3 mb-4 sm:mb-6 max-w-4xl">
            <div className="h-8 sm:h-10 md:h-12 bg-border/50 rounded animate-pulse w-full" />
            <div className="h-8 sm:h-10 md:h-12 bg-border/50 rounded animate-pulse w-3/4" />
          </div>

          {/* Meta */}
          <div className="flex flex-wrap items-center gap-4 sm:gap-6 mb-6 sm:mb-8">
            <div className="h-4 w-24 bg-border/50 rounded animate-pulse" />
            <div className="h-4 w-28 bg-border/50 rounded animate-pulse" />
            <div className="h-4 w-20 bg-border/50 rounded animate-pulse" />
          </div>

          {/* Tags */}
          <div className="flex flex-wrap gap-2">
            <div className="h-6 w-16 bg-border/50 rounded-full animate-pulse" />
            <div className="h-6 w-20 bg-border/50 rounded-full animate-pulse" />
            <div className="h-6 w-14 bg-border/50 rounded-full animate-pulse" />
          </div>
        </div>
      </section>

      {/* Content Section Skeleton */}
      <section className="pb-16 sm:pb-20 bg-bg-alt">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
            {/* Main Content */}
            <div className="flex-1 min-w-0">
              <div className="bg-white border border-border rounded-xl sm:rounded-2xl p-5 sm:p-6 md:p-8">
                {/* Content paragraphs skeleton */}
                <div className="space-y-4">
                  {/* Paragraph 1 */}
                  <div className="space-y-2">
                    <div className="h-4 bg-border/50 rounded animate-pulse w-full" />
                    <div className="h-4 bg-border/50 rounded animate-pulse w-full" />
                    <div className="h-4 bg-border/50 rounded animate-pulse w-4/5" />
                  </div>

                  {/* Heading */}
                  <div className="h-6 bg-border/50 rounded animate-pulse w-1/3 mt-6" />

                  {/* Paragraph 2 */}
                  <div className="space-y-2">
                    <div className="h-4 bg-border/50 rounded animate-pulse w-full" />
                    <div className="h-4 bg-border/50 rounded animate-pulse w-full" />
                    <div className="h-4 bg-border/50 rounded animate-pulse w-3/5" />
                  </div>

                  {/* Image placeholder */}
                  <div className="h-48 sm:h-64 bg-border/50 rounded-lg animate-pulse my-6" />

                  {/* Paragraph 3 */}
                  <div className="space-y-2">
                    <div className="h-4 bg-border/50 rounded animate-pulse w-full" />
                    <div className="h-4 bg-border/50 rounded animate-pulse w-full" />
                    <div className="h-4 bg-border/50 rounded animate-pulse w-full" />
                    <div className="h-4 bg-border/50 rounded animate-pulse w-2/3" />
                  </div>

                  {/* Heading */}
                  <div className="h-6 bg-border/50 rounded animate-pulse w-2/5 mt-6" />

                  {/* Paragraph 4 */}
                  <div className="space-y-2">
                    <div className="h-4 bg-border/50 rounded animate-pulse w-full" />
                    <div className="h-4 bg-border/50 rounded animate-pulse w-full" />
                    <div className="h-4 bg-border/50 rounded animate-pulse w-4/5" />
                  </div>
                </div>
              </div>
            </div>

            {/* Sidebar - Table of Contents Skeleton */}
            <div className="hidden lg:block w-64 flex-shrink-0">
              <div className="sticky top-32">
                <div className="bg-white border border-border rounded-xl p-5 sm:p-6 shadow-sm">
                  {/* TOC Title */}
                  <div className="h-4 w-24 bg-border/50 rounded animate-pulse mb-4" />

                  {/* TOC Items */}
                  <div className="space-y-3">
                    <div className="h-3 bg-border/50 rounded animate-pulse w-3/4" />
                    <div className="h-3 bg-border/50 rounded animate-pulse w-full ml-3" />
                    <div className="h-3 bg-border/50 rounded animate-pulse w-4/5 ml-3" />
                    <div className="h-3 bg-border/50 rounded animate-pulse w-2/3" />
                    <div className="h-3 bg-border/50 rounded animate-pulse w-full ml-3" />
                    <div className="h-3 bg-border/50 rounded animate-pulse w-3/5" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  )
}
